module.exports = __webpack_public_path__ + "img/4.9fc574b8.jpg";